import { render, staticRenderFns } from "./TheCatalogFilterExport.vue?vue&type=template&id=a96c5c86&"
import script from "./TheCatalogFilterExport.vue?vue&type=script&lang=js&"
export * from "./TheCatalogFilterExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports